import { connect } from 'react-redux';

const mapStateToProps = state => ({
  selectedLocations: state.mainreducer.selectedLocations,
});

export default VirtualTourRightPart => connect(mapStateToProps, null)(VirtualTourRightPart);
